// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2842H","lds-ripple":"Loader_lds-ripple__1DuvU","center":"Loader_center__2GBWo"};